import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/page/Conf2024/index.vue"),
    meta: {
      title: "2024 컨퍼런스",
    },
  },
  {
    path: "/question",
    component: () => import("@/page/Conf2024/question.vue"),
    meta: {
      title: "사전 질문하기",
    },
  },
  {
    path: "/complete",
    component: () => import("@/page/Conf2024/complete.vue"),
    meta: {
      title: "신청 완료",
    },
  },
];

const conf2024 = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }
  },
});

conf2024.afterEach((to) => {
  const title = to.meta.title === undefined ? "CarrotSolutions" : to.meta.title;
  Vue.nextTick(() => {
    document.title = title;
  });
});

export default conf2024;
